<template>
  <div class="ds-control mobile dsf_teas_class_info">
    <div class="search">
      <van-search v-model="keywords" shape="round" @input="search" placeholder="搜索" />
    </div>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length > 0">
        <van-list v-model="loading" :finished="finished" :error.sync="error" finished-text="没有更多了" @load="getList">
          <!-- <div class="list">
            <div class="list-item" v-for="(item, index) in list" :key="index" @click="itemClick(item)">
              <div class="class-name">{{item.state==1?'【在校班次】':'【历史班次】'}}{{ item.className }}</div>
              <div class="time">{{ item.trainSdate | dateFormat }} 至 {{ item.trainEdate | dateFormat }}</div>
              <div class="row">
                <div class="num">{{ item.num }}人</div>
                <div class="department">{{ item.classType }}</div>
                <div class="rate">考勤率 {{ item.attendRate }}</div>
              </div>
            </div>
          </div> -->
          <div class="list">
            <DsfMobileTeasCell v-for="(item, index) in list" :titleEllipsis="2" @click.native="itemClick(item)" :key="index" :title="item.className">
              <DsfMobileTeasCellItem icon="icon-icon-date" :value="getDate(item)"></DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem icon="icon-icon-num" :value="item.num || '0人'"></DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem icon="icon-icon-classType" :value="item.classType || '暂无'"></DsfMobileTeasCellItem>
              <div slot="ft" class="attendance">
                <span>{{ item.attendRate }}</span>
                <div>考勤率</div>
              </div>
            </DsfMobileTeasCell>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>
  </div>
</template>

<script>
const testData = [
  {
    classId: "db0f04d715a042019eaad469d11416a7",
    className: "排课011",
    trainSdate: "2021-02-16 00:00:00",
    trainEdate: "2021-06-26 00:00:00",
    num: 0,
    attendRate: "0%",
    classType: null,
    state: "1",
    attendMode: "1",
  },
  {
    classId: "892ccac7a7b0434098f1023a1764fbcc",
    className: "测测",
    trainSdate: "2021-02-17 00:00:00",
    trainEdate: "2021-04-07 00:00:00",
    num: 0,
    attendRate: "0%",
    classType: null,
    state: "1",
    attendMode: "1",
  },
];
export default dsf.component({
  name: "DsfMobileTeasClassInfo",
  mixins: [$mixins.control],
  ctrlCaption: "班次信息-校领导",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: '/teas/mobile/attendance/queryAllCurrentAndHistoryClass',
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      keywords: "",
      list: [],
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.getList();
    }
  },
  filters: {
    dateFormat(date) {
      if (date) {
        return date.split(' ')[0]
      }
      return ''
    }
  },
  methods: {
    itemClick(item) {
      if (item.attendMode === '1') { // 课程考勤
        this.$router.push('/mobile/teas/attendance/mobile/mobile-bckcxx?classId=' + item.classId + '&elective=0')
      } else { // 午别考勤
        this.$router.push('/mobile/teas/attendance/mobile/mobile-bcwbkq?classId=' + item.classId + '&elective=0')
      }
    },
    search: _.debounce(function () {
      this.onRefresh()
    }, 300),
    getDate(val) {
      if (val) {
        return val.trainSdate.split(' ')[0] + ' 至 ' + val.trainEdate.split(' ')[0]
      } else {
        return ''
      }
    },
    // 获取列表数据
    getList(isRefresh = false) {
      const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .get(this.$replace(this.sourcesUrl, this), {
          pageNum: this.pageNum,
          search: this.keywords
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (isRefresh) {
              this.list = res.data.list
            } else {
              this.list.push(...res.data.list);
            }
            this.finished = res.data.lastPage
            console.log('res.data.lastPage', res.data.lastPage)
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true
        })
        .always(() => {
          this.loading = false
          this.refreshing = false
          dsf.layer.closeLoading(loading);
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0
      this.getList(true)
    },
  },
});
</script>